import { Text } from "~/components/Text/Text";
import { Box } from "~/components/Box/Box";
import { Button } from "~/components/Button/Button";
import { Stack } from "../Stack/Stack";
import { useEmbedded } from "~/hooks/embedded";
import { EmbeddedToolbar } from "../EmbeddedToolbar/EmbeddedToolbar";
import { SafeAreaTop } from "../SafeArea/SafeArea";
import { ButtonLink } from "../ButtonLink/ButtonLink";
import Image from "next/image";

export default function AppError(props: {
  error: Error & { digest?: string };
  reset: () => void;
  redirect?: { label: string; href: string };
  hideEmbeddedToolbar?: boolean;
}) {
  const { error, reset, redirect, hideEmbeddedToolbar } = props;
  const { isEmbedded, closeEmbeddedWebView } = useEmbedded();

  return (
    <>
      {isEmbedded && !hideEmbeddedToolbar && (
        <>
          <EmbeddedToolbar
            title="Error"
            design="original"
            onBack={closeEmbeddedWebView}
          />
          <SafeAreaTop />
        </>
      )}

      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="full"
        width="full"
        padding="10"
      >
        <Stack align="center" space="8">
          <Text size="large" align="center" weight="strong">
            Something has gone wrong
          </Text>
          <Image
            src="/images/jetserror.png"
            width={297}
            height={230}
            alt="Error Image"
          />
          <Box>
            <Text align="center">We&#39;ve logged the error.</Text>
            <Text align="center">
              Please try again or return to the home page
            </Text>
          </Box>
          <Stack space="4">
            <Button onClick={reset} primary>
              Try again
            </Button>
            {redirect && (
              <>
                {isEmbedded ? (
                  <Button onClick={closeEmbeddedWebView} primary>
                    {redirect.label}
                  </Button>
                ) : (
                  <ButtonLink href={redirect.href} primary>
                    {redirect.label}
                  </ButtonLink>
                )}
              </>
            )}
          </Stack>
          <Text size="small" weight="medium">
            More Info: {error.message}
          </Text>
        </Stack>
      </Box>
    </>
  );
}
